import { configureStore } from "@reduxjs/toolkit";
import headerReducer from "./headerSlice";
import batchResultReducer from "./batchResultSlice";

const store = configureStore({
  reducer: {
    header: headerReducer,
    batchResult: batchResultReducer
  },
});

export default store;
